import { openToast } from '@web/components/Toast/GlobalToastPortal'
import { IS_DEV } from '@web/libs/constants'

export const LANDING_DEBUG_MODE = 'LANDING_DEBUG_MODE'

export const debugLanding = ({ url, type }: { url: string; type?: 'openWindow' | 'replace' | 'push' }) => {
  const isLandingDebugMode = sessionStorage.getItem(LANDING_DEBUG_MODE)

  const isAvailable = isLandingDebugMode === 'true' && IS_DEV

  if (!isAvailable) return false
  const log = `[DebugLanding] ${type} - ${url}`

  console.debug(log)

  openToast({ title: log, top: 0, hideTime: 5000 })

  return true
}
